import { useState } from 'react';
import { useDispatch } from 'react-redux';

// Services

import CalendarService from '../services/calendar.service';
import { setIsWithinWorkHours } from '../store/calendar/calendar.actions';

export default function CheckIfTimeIsWithinWorkHours() {
    const [checkWorkHoursIsLoading, setCheckWorkHoursIsLoading] = useState(false);
    const [inWorkHours, setInWorkHours] = useState(null);
    const dispatch = useDispatch();

    // Consult if the current time is within work hours/days

    const handleCheckIfTimeIsWithinWorkHours = async () => {
        setCheckWorkHoursIsLoading(true);
        setInWorkHours(null);

        try {
            const response = await CalendarService.consultaDiasFeriados();
            setCheckWorkHoursIsLoading(false);

            if (response.status === 200 && response.data?.data?.codigoError === '1') {
                setInWorkHours(true);
                dispatch(setIsWithinWorkHours(true));
            } else {
                setInWorkHours(false);
                dispatch(setIsWithinWorkHours(false));
            }
        } catch(error) {
            setCheckWorkHoursIsLoading(false);
            setInWorkHours(false);
            dispatch(setIsWithinWorkHours(false));
        }
    }

    return {
        checkWorkHoursIsLoading,
        inWorkHours,
        handleCheckIfTimeIsWithinWorkHours,
    }
}
